import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Autocomplete, Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { GrNext } from "react-icons/gr";
import { GrPrevious } from "react-icons/gr";

import { TablePaginationActions } from '../../../helpers/TablePaginationActions';

import { usePages } from '../../../hooks/usePages';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";
import { setReducerAnexos, setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';

import { DialogContentStyle, DialogActionsStyle } from '../../../styles/DialogStyle';

import { ObtenerTipoAnexo } from '../../../connections/catalogos/TipoAnexoConnection';
import { ObtenerTipoFormato } from '../../../connections/catalogos/TipoFormatoConnection';
import { AgregarAnexosAmparo } from '../../../connections/comun/AmparoConnection';
import { ActualizarEstatus } from '../../../connections/comun/RecepcionConnection';

import { AnexoProps } from '../../../interfaces/comun/AnexoInterface';
import { TipoAnexoProps } from '../../../interfaces/catalogos/TipoAnexoInterface';
import { TipoFormatoProps } from '../../../interfaces/catalogos/TipoFormatoInterface';
import { GenerarAmparo } from '../../../connections/comun/AmparoConnection';
import { AgregarAnexosAmparoParams } from '../../../interfaces/comun/AmparoInterface';

interface Props {
    numeroSeguimiento:      number;    
    handleNext:             () => void;
    handleBack:             () => void;
    setAjaxFinish:          React.Dispatch<React.SetStateAction<boolean>>;  
    setMensajeAsignacion:   React.Dispatch<React.SetStateAction<string>>;
}

export const RegistrarAnexosPage = ({ numeroSeguimiento, handleNext, handleBack, setAjaxFinish, setMensajeAsignacion }: Props ) => {

    const dispatch = useDispatch();
    
    const recepcion = useSelector( ( state: RootState ) => state.recepcion );
  
    const [tipoAnexo, setTipoAnexo] = useState( 0 );
    const [tipoAnexoArray, setTipoAnexoArray] = useState<TipoAnexoProps[]>( [] );
    const [autocompleteValue, setAutocompleteValue] = useState<TipoAnexoProps | null>( null );  
    const [autocompleteValueEdit, setAutocompleteValueEdit] = useState<TipoAnexoProps | null>( null );  

    const [tipoFormato, setTipoFormato] = useState( 0 );
    const [tipoFormatoEdit, setTipoFormatoEdit] = useState( 0 );
    const [tipoFormatoArray, setTipoFormatoArray] = useState<TipoFormatoProps[]>( [] );
    
    const [cantidad, setCantidad] = useState( 1 );
    const [cantidadEdit, setCantidadEdit] = useState( 1 );

    const [numeroFojas, setNumeroFojas] = useState( 1 );
    const [numeroFojasEdit, setNumeroFojasEdit] = useState( 1 );
    
    const [observaciones, setObservaciones] = useState( '' );
    const [observacionesEdit, setObservacionesEdit] = useState( '' );

    const [openConfirmacion, setOpenConfirmacion] = useState(false);
    const [openGenerarAmparo, setOpenGenerarAmparo] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);

    const [rows, setRows] = useState<AnexoProps[]>( [ ] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );    

    const [loadingBack, setLoadingBack] = useState( false );
    const [loadingSave, setLoadingSave] = useState( false );

    const [loadingGenerarAmparo, setLoadingGenerarAmparo] = useState( false );   
    
    const [idReferencia, setIdReferencia] = useState(0);

    const handleClicAgregarAnexo = () => {

        const id = new Date().getUTCSeconds() + '' + new Date().getUTCMilliseconds();

        const tipoAnexoData =  tipoAnexoArray.find( ( e ) => e.idTipoAnexo === tipoAnexo );
        const tipoFormatoData =  tipoFormatoArray.find( ( e ) => e.idTipoFormato === tipoFormato );

        const data: AnexoProps = {
            id: parseInt( id ),
            idTipoAnexo: tipoAnexo,
            tipoAnexo: tipoAnexoData?.descripcion ?? '',
            idTipoFormato: tipoFormato,
            tipoFormato: tipoFormatoData?.descripcion ?? '',
            cantidad: cantidad,
            numeroFojas: numeroFojas,
            observaciones: observaciones
        };

        setRows( [ ...rows, data ] );

        setTipoAnexo( 0 );
        setTipoFormato( 0 );
        setCantidad( 1 );
        setNumeroFojas( 1 );
        setObservaciones( '' );
        setAutocompleteValue( null );

    }

    const handleClicEditarAnexo = () => {

        const tipoFormatoData = tipoFormatoArray.find( (e) => e.idTipoFormato === tipoFormatoEdit );
        
        var newArray = rows.filter(  (e) => e.id !== idReferencia );
        var editRow = rows.find( (e) => e.id === idReferencia );

        if( editRow ){

            var data: AnexoProps = { 
                ...editRow,  
                idTipoAnexo: autocompleteValueEdit?.idTipoAnexo ?? 0,
                tipoAnexo: autocompleteValueEdit?.descripcion ?? '',
                idTipoFormato: tipoFormatoData?.idTipoFormato ?? 0,
                tipoFormato: tipoFormatoData?.descripcion ?? '',
                cantidad: cantidadEdit,
                numeroFojas: numeroFojasEdit,
                observaciones: observacionesEdit ?? '',
            };
    
            setRows([ ...newArray, data ]);
            setOpenEdit( false );
        }

    }

    const handleClicRemoverAnexo = () => {

        var newArray = rows.filter( ( e ) => e.id !== idReferencia );

        setRows( newArray );
        setOpenConfirmacion( false );

    }

    const Guardar = async () => {

        const params: AgregarAnexosAmparoParams = { 
            id: recepcion.id ?? '', 
            anexos: rows,
        };

        const request = await AgregarAnexosAmparo( params );  

        if( request.success ){
            dispatch( setReducerAnexos({ anexos: rows }) );
        }

        return request;
    }

    const handleGuardar = async () => {

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));  
                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleRegresar = async () => {

        setLoadingBack( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'warning' }));  
                    setLoadingBack( false );
    
                }, 700);
            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 5 }).then( resp => {
                
            const { success, message } = resp;

            if( success ){

                setTimeout(() => {

                    handleBack();
                    setLoadingBack( false );
                    
                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));                      
                    setLoadingBack( false );

                }, 700);

            }

        }); 

    }

    const handleGenerarAmparo = async() => {

        setLoadingGenerarAmparo( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){          
                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'warning' }));  
                    setLoadingGenerarAmparo( false );
    
                }, 700);
            }

        }

        await GenerarAmparo({ id: recepcion.id ?? '' }).then( resp => {   

            const { success, message, numeroAmparo, usuarioActualAsignacion, usuarioAsignacion } = resp;

            if( success ){   
                    
                setTimeout(() => {
                    
                    setLoadingGenerarAmparo( false );

                    dispatch( setReducerRecepcion({ ...recepcion, numeroAmparo: numeroAmparo ?? '' }) );

                    if( usuarioActualAsignacion ){
                        handleNext();
                    }
                    else{                        
                        setAjaxFinish( true );
                        setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( usuarioAsignacion ?? '' ) );  
                    }

                }, 700);       

            }
            else{                    

                setTimeout(() => {

                    dispatch( openSnackbar({ message: message, variant: 'warning' }));  
                    setLoadingGenerarAmparo( false );         
                    setOpenGenerarAmparo( false );                               

                }, 700);
            }        

        });       

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoAnexo().then( resp => {  
                setTipoAnexoArray( resp );    
            });

        }

        Obtener();

    }, [ ]);   

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoFormato().then( resp => {  
                setTipoFormatoArray( resp );    
            });

        }

        Obtener();

    }, [ ]);   

    useEffect(() => {
     
        if( recepcion.anexos?.length !== 0 ){
            setRows( recepcion.anexos ?? [] );
        }
        
    }, [ recepcion ])    

    return (
        <Grid container spacing={3}>

            <Grid size={{ xs: 12, md: 12 }}>
            
                <Card sx={{ mt: 2 }}>
                
                    <CardHeader 
                        sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                        subheader={ 
                            <Grid container spacing={3}>

                                <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                    <Typography variant='h6' sx={{ color: 'white' }}> Registrar anexo(s) </Typography> 
                                </Grid>
                            
                                <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                    <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                </Grid>

                            </Grid>
                        }
                    />
                
                    {
                        !recepcion.acuseFirmado
                        &&
                            <CardContent sx={{ p: 3 }}>

                                <Grid container spacing={3}>

                                    <Grid size={{ md: 4, xs: 12 }} >                            
                                    
                                        <FormControl fullWidth>

                                            <Autocomplete                
                                                
                                                fullWidth              
                                                value={ autocompleteValue }   
                                                options={ tipoAnexoArray }
                                                onChange={ (event, value) => { setTipoAnexo( value?.idTipoAnexo ?? 0 ); setAutocompleteValue( value ); } }                        
                                                getOptionLabel={ (option) => option.descripcion}
                                                renderOption={ ( props, option ) => (
                                                    <li { ...props } key={ option.idTipoAnexo} style={{ paddingTop: 10, paddingBottom: 10, }}>                         
                                                        { option.descripcion }
                                                    </li>
                                                )}
                                                renderInput={ ( params ) => <TextField {...params} label="Tipo de anexo" placeholder='Seleccione una opción' slotProps={{ inputLabel: { shrink: true, } }} /> }         
                                            />      

                                        </FormControl>

                                    </Grid> 

                                    <Grid size={{ md: 4, xs: 12 }} >       

                                        <FormControl fullWidth>
                                            <InputLabel>Tipo de formato</InputLabel>
                                        
                                            <Select                                                                                  
                                                label="Tipo de formato"
                                                value={ tipoFormato }
                                                onChange={ ( e ) => { setTipoFormato( e.target.value ); } }
                                            >
                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                 
                                                {
                                                    tipoFormatoArray.map( ({ idTipoFormato, descripcion }) => (                                            
                                                        <MenuItem key={idTipoFormato} value={idTipoFormato}>{ descripcion }</MenuItem>                 
                                                    ))
                                                }
                                            </Select>

                                        </FormControl>

                                    </Grid> 

                                    <Grid size={{ md: 2, xs: 12 }} >

                                        <FormControl>

                                            <InputLabel shrink>Cantidad</InputLabel>
                                            <OutlinedInput
                                                fullWidth
                                                label="Cantidad"  
                                                type="number"                                            
                                                value={ cantidad }                    
                                                onChange={ (e) => {                                                     
                                                    if( e.target.value === '' ){
                                                        setCantidad( 0 );
                                                    }
                                                    else {
                                                        setCantidad( parseInt( e.target.value.toString() ?? '0' ) )
                                                    }
                                                }}       
                                                slotProps={{ input: { min: 1 } }}
                                            />

                                        </FormControl>

                                    </Grid>  

                                    <Grid size={{ md: 2, xs: 12 }} >

                                        <FormControl>

                                            <InputLabel shrink>Número de fojas</InputLabel>
                                            <OutlinedInput
                                                fullWidth
                                                label="Número de fojas"
                                                type="number"                                            
                                                value={ numeroFojas }                    
                                                onChange={ (e) => {                                                     
                                                    if( e.target.value === '' ){
                                                        setNumeroFojas( 0 );
                                                    }
                                                    else {
                                                        setNumeroFojas( parseInt( e.target.value.toString() ?? '0' ) )
                                                    }
                                                }}     
                                                slotProps={{ input: { min: 1 } }}
                                            />

                                        </FormControl>

                                    </Grid>  

                                    <Grid size={{ md: 10, xs: 12 }} >

                                        <TextField
                                            fullWidth
                                            label="Observaciones"
                                            variant="outlined"        
                                            multiline
                                            rows={4}              
                                            value={ observaciones }
                                            onChange={ ( e ) => { setObservaciones( e.target.value ); } }                                
                                        />

                                    </Grid>

                                    <Grid size={{ md: 2, xs: 12 }} >

                                        <Button 
                                            fullWidth
                                            variant="contained"      
                                            disabled={ tipoAnexo === 0 || tipoFormato === 0 }
                                            onClick={ handleClicAgregarAnexo }
                                        >
                                            Agregar
                                        </Button>

                                    </Grid>   

                                </Grid>   

                            </CardContent>
                    }
                        
                </Card>  

            </Grid>

            <Grid size={{ md: 12, xs: 12 }} >

                <TableContainer sx={{ borderRadius: 3, mt: 1 }}>
                                                                
                    <Table sx={{ minWidth: 500 }}>         

                        <TableHead sx={{ ...TableTheadStyle }}>

                            <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>  
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}>Tipo de anexo</TableCell>                              
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}>Tipo de formato</TableCell>                              
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}>Cantidad</TableCell>    
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}>Número de fojas</TableCell>   
                                <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}>Observaciones</TableCell>                                         
                                { !recepcion.acuseFirmado && <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}> </TableCell> }
                            </TableRow>

                        </TableHead>

                        <TableBody>       

                            {
                                (
                                    rowsPerPage > 0
                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : rows
                                ).map( ( { id, idTipoAnexo, tipoAnexo, idTipoFormato, tipoFormato, cantidad, numeroFojas, observaciones }, index ) => (
                            
                                    <TableRow key={ index }>
                                        <TableCell>{ tipoAnexo }</TableCell>    
                                        <TableCell>{ tipoFormato }</TableCell>    
                                        <TableCell sx={{ textAlign: 'center' }}>{ cantidad }</TableCell>    
                                        <TableCell sx={{ textAlign: 'center' }}>{ numeroFojas }</TableCell>     
                                        <TableCell>{ observaciones }</TableCell>                              
                                       
                                        {
                                            !recepcion.acuseFirmado
                                            &&
                                                <TableCell sx={{ textAlign: 'end' }}> 
                                                 
                                                    <IconButton 
                                                        color="primary" 
                                                        onClick={ () => { 
                                                            setIdReferencia( id ); 

                                                            var tipoAnexoFind = tipoAnexoArray.find( (e) => e.idTipoAnexo === idTipoAnexo );
                                                            if( tipoAnexoFind ){
                                                                setAutocompleteValueEdit( tipoAnexoFind );
                                                            }

                                                            setTipoFormatoEdit( idTipoFormato );
                                                            setCantidadEdit( cantidad );
                                                            setNumeroFojasEdit( numeroFojas );
                                                            setObservacionesEdit( observaciones ?? '' );

                                                            setOpenEdit( true ); 
                                                        }}
                                                    >
                                                        <EditIcon />                                                    
                                                    </IconButton>
                                                 
                                                    <IconButton sx={{ ml: 1 }} color="primary" onClick={ () => { setIdReferencia( id ); setOpenConfirmacion( true ); }}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                        }

                                    </TableRow>
                                
                                ))
                            }

                            {
                                rows.length === 0 
                                &&                                 
                                    <TableRow>
                                        <TableCell
                                            colSpan={6}
                                            align="center"
                                            style={{ fontWeight: 'bold', fontSize: 14 }}
                                        >
                                            <Typography variant="caption" color='secondary'> No se han agregado anexo(s) </Typography>
                                        </TableCell>
                                    </TableRow>                                
                            }

                        </TableBody>

                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[ ]}
                                    colSpan={6}
                                    count={rows.length}                                        
                                    rowsPerPage={rowsPerPage}
                                    page={page}                                                                                
                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }
                                    ActionsComponent={ TablePaginationActions }
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                        return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />
                            </TableRow>
                        </TableFooter>

                    </Table>

                </TableContainer>

            </Grid> 
     
            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>  

                <Grid container spacing={3}>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'left' }}>
                        <IconButton
                            color='primary'
                            onClick={ handleRegresar }
                            loading={ loadingBack }
                        >
                            <GrPrevious />
                        </IconButton>
                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} sx={{ textAlign: 'center '}}>

                        {
                            !recepcion.acuseFirmado
                            &&
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    onClick={ handleGuardar }
                                    loading={ loadingSave }
                                > 
                                    Guardar 
                                </Button>
                        }                    

                    </Grid>

                    <Grid size={{ md: 4, xs: 4 }} style={{ textAlign: 'right' }}>  
                        <IconButton 
                            color='primary'
                            loading={ recepcion.acuseFirmado !== '' && loadingGenerarAmparo }
                            onClick={ () => !recepcion.acuseFirmado ? setOpenGenerarAmparo( true ) : handleGenerarAmparo() }
                        > 
                           <GrNext />
                        </IconButton>
                    </Grid>                                        

                </Grid>

            </Grid> 
          
            <Dialog   
                maxWidth='sm' 
                fullWidth={true}
                disableEscapeKeyDown
                open={ openEdit } 
                onClose={ () => { } }
            >

                <DialogTitle>
                    Editar
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ md: 12, xs: 12 }} >                            
                                    
                            <FormControl fullWidth>

                                <Autocomplete                
                                    
                                    fullWidth              
                                    value={ autocompleteValueEdit }   
                                    options={ tipoAnexoArray }
                                    onChange={ (event, value) => { setAutocompleteValueEdit( value ); } }                        
                                    getOptionLabel={ (option) => option.descripcion}
                                    renderOption={ ( props, option ) => (
                                        <li { ...props } key={ option.idTipoAnexo} style={{ paddingTop: 10, paddingBottom: 10, }}>                         
                                            { option.descripcion }
                                        </li>
                                    )}
                                    renderInput={ ( params ) => <TextField {...params} label="Tipo de anexo" placeholder='Seleccione una opción' slotProps={{ inputLabel: { shrink: true, } }} /> }         
                                />      

                            </FormControl>

                        </Grid> 

                        <Grid size={{ md: 12, xs: 12 }}>   
                                                     
                            <FormControl fullWidth>
                                <InputLabel>Tipo de formato</InputLabel>
                            
                                <Select                                                                  
                                    label="Tipo de formato"
                                    value={ tipoFormatoEdit }
                                    onChange={ ( e ) => { setTipoFormatoEdit( e.target.value ); } }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                 
                                    {
                                        tipoFormatoArray.map( ({ idTipoFormato, descripcion }) => (                                            
                                            <MenuItem key={idTipoFormato} value={idTipoFormato}>{ descripcion }</MenuItem>                 
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid> 
            
                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>

                                <InputLabel shrink>Cantidad</InputLabel>
                                <OutlinedInput
                                    fullWidth
                                    label="Cantidad"  
                                    type="number"                                            
                                    value={ cantidadEdit }                    
                                    onChange={ (e) => {                                                     
                                        if( e.target.value === '' ){
                                            setCantidadEdit( 0 );
                                        }
                                        else {
                                            setCantidadEdit( parseInt( e.target.value.toString() ?? '0' ) )
                                        }
                                    }}       
                                    slotProps={{ input: { min: 1 } }}
                                />

                            </FormControl>

                        </Grid>  

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>

                                <InputLabel shrink>Número de fojas</InputLabel>
                                <OutlinedInput
                                    fullWidth
                                    label="Número de fojas"
                                    type="number"                                            
                                    value={ numeroFojasEdit }                    
                                    onChange={ (e) => {                                                     
                                        if( e.target.value === '' ){
                                            setNumeroFojasEdit( 0 );
                                        }
                                        else {
                                            setNumeroFojasEdit( parseInt( e.target.value.toString() ?? '0' ) )
                                        }
                                    }}     
                                    slotProps={{ input: { min: 1 } }}
                                />

                            </FormControl>

                        </Grid>   

                        <Grid size={{ md: 12, xs: 12 }} >

                            <TextField
                                fullWidth
                                label="Observaciones"
                                variant="outlined"        
                                multiline
                                rows={4}              
                                value={ observacionesEdit }
                                onChange={ ( e ) => { setObservacionesEdit( e.target.value ); } }                                
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary'  onClick={ () => setOpenEdit( false ) }> Cancelar </Button>
                    <Button onClick={ handleClicEditarAnexo } variant='contained' disabled={ autocompleteValueEdit === null || tipoFormatoEdit === 0 || cantidadEdit < 1 || numeroFojasEdit < 1 }> Guardar </Button>
                </DialogActions>
            </Dialog>

            <Dialog 
                maxWidth='xs'    
                fullWidth={true}
                disableEscapeKeyDown
                open={ openConfirmacion } onClose={ () => {} }  
            >
                
                <DialogTitle>
                    Confirmación
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                
                    <DialogContentText>
                        ¿Desea quitar el registro seleccionado?
                    </DialogContentText>
                
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>
                    <Button onClick={ handleClicRemoverAnexo } variant='contained' > Aceptar </Button>
                    
                </DialogActions>

            </Dialog>

            <Dialog    
                maxWidth='sm'    
                fullWidth={true}
                disableEscapeKeyDown
                open={ openGenerarAmparo } 
                onClose={ () => {} } 
            >
                
                <DialogTitle>
                    Confirmación
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                
                    <DialogContentText>
                        ¿Desea generar el acuse de recibo con la información registrada?
                    </DialogContentText>
                
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingGenerarAmparo } onClick={ () => setOpenGenerarAmparo( false ) }> Cancelar </Button>
                    <Button 
                        onClick={ handleGenerarAmparo } 
                        variant='contained' 
                        loading={ loadingGenerarAmparo }
                    > 
                        Aceptar 
                    </Button>
                    
                </DialogActions>

            </Dialog>
               
        </Grid>
    )
}
